import styled from 'styled-components';

import BadgeOriginal from '../../Puck/Puck';
import Button from '../../Button/Button';

export const NotificationIcon = styled(Button).attrs({
  variant: 'secondary',
  isGhost: true
})`
  position: relative;
  display: inline-block;
  font-weight: normal;
  height: 64px;
  width: 48px;
  padding: 0;
  min-width: auto;
  &:hover, :focus {
    opacity: 1;
    background-color: transparent;
  }
`;

export const Badge = styled(BadgeOriginal)`
  position: absolute;
  top: 7px;
  right: -1px;
`;
